import { skipToken } from '@reduxjs/toolkit/query';
import { SportType } from 'modules/core/domain/enums/sport-type';
import { useOrganizer } from 'modules/organizer/ui/hooks/use-organizer';
import { useListTeamsQuery } from 'modules/teams/store/teams-api';
import { useMemo } from 'react';

/** Сколько команд организации показать разом — этого достаточно, чтобы не городить пагинацию здесь. */
const TEAMS_LIMIT = 100;

/**
 * Команды организации, ещё не привязанные к турниру ни в каком статусе.
 *
 * Общий источник для `UnclaimedTeamsList` (сам список) и `ChampionshipApplications`
 * (счётчик вкладки «Незаявленные») — раньше счётчик знал только про уже привязанные
 * команды (`announcedTeams`) и показывал 0, пока список ниже уже показывал команды
 * организации, ещё не добавленные в турнир.
 */
export function useUnclaimedTeams(excludeTeamIds: number[]) {
  const { info } = useOrganizer();

  const { data: teams, isLoading } = useListTeamsQuery(
    info ? { tournamentId: info.id, sportType: info.sportType ?? SportType.football, limit: TEAMS_LIMIT, offset: 0 } : skipToken,
  );

  const excludeIds = useMemo(() => new Set(excludeTeamIds), [excludeTeamIds]);
  const availableTeams = useMemo(() => (teams ?? []).filter((team) => !excludeIds.has(team.id)), [teams, excludeIds]);

  return { availableTeams, isLoading };
}
